const columns = [
  { Header: '#', accessor: 'num', excelEnabled: false, width: 180, align: 'right' },
  { Header: 'Estado', accessor: 'proc_status', excelEnabled: false, width: 105 },
  { Header: 'Zona', accessor: 'base_zone_description', width: 150 },
  { Header: 'Almacén', accessor: 'WhsName', width: 180 },
  { Header: 'Forma pago', accessor: 'GroupNum', width: 140 },
  { Header: 'Fec. Comprob.', accessor: 'tax_date', width: 150 },
  { Header: 'Cód. proveedor', accessor: 'CardCode', width: 140 },
  { Header: 'Nombre proveedor', accessor: 'cardName' },
  { Header: 'RUC / DNI', accessor: 'LicTradNum', width: 130 },
  { Header: 'Guía', accessor: 'is_guide', width: 80, align: 'center' },
  { Header: 'T. Comprobante', accessor: 'ReceiptType', width: 140 },
  { Header: 'Serie sunat', accessor: 'ReceiptSerie', width: 130 },
  { Header: 'Núm. sunat', accessor: 'ReceiptNumber', width: 130 },
  { Header: 'Total Doc.', accessor: 'DocTotal', width: 130, align: 'right' },
  { Header: 'Op. Fravada', accessor: 'op_gravada', width: 130, align: 'right' },
  { Header: 'Op. Inafecta', accessor: 'op_inafecta', width: 130, align: 'right' },
  { Header: 'Op. Exonerada', accessor: 'op_exonerada', width: 130, align: 'right' },
  { Header: 'Igv monto', accessor: 'VatSum', width: 130, align: 'right' },
  { Header: 'Impu. Consum.', accessor: 'SumIsc', width: 140 },
  { Header: 'Otros tributos', accessor: 'SumOtTrib', width: 140 },
  { Header: 'Otros cargos', accessor: 'SumOtCarg', width: 140 },
  { Header: 'Desc.', accessor: 'total_discount', width: 100, align: 'right' },
  { Header: 'Total Impu.', accessor: 'VatSumTotal', width: 130, align: 'right' },
  { Header: 'Moneda', accessor: 'Currency', width: 100, align: 'center' },
  { Header: 'Fec. Vto.', accessor: 'DocDueDate', width: 130 },
  { Header: '% Desc.', accessor: 'DiscPrcnt', width: 100, align: 'center' },
  { Header: 'Desc. Monto', accessor: 'DiscSum', width: 130, align: 'right' },
  { Header: 'Estado Doc.', accessor: 'doc_status', width: 130 },
  { Header: 'Trans. Gratis', accessor: 'sum_free_transfer', width: 130, align: 'right' },
  { Header: 'Suma Bonif.', accessor: 'sum_bonification', width: 120, align: 'right' },
  { Header: 'Suma Igv', accessor: 'sum_igv', width: 120, align: 'right' },
  { Header: 'Fec. Creación', accessor: 'created_at', width: 130 },
  { Header: 'Fec. Actuali.', accessor: 'updated_at', width: 130 },
  { Header: 'Fec. Conta', accessor: 'DocDate', width: 110 },
  { Header: 'Últ. Fec. proceso', accessor: 'last_process_date', width: 150 },
  { Header: '', accessor: 'actions', excelEnabled: false, width: 0 },
];

export default columns;
